import React, { createContext, useRef } from 'react';

import { pl } from './pl';

export interface TrasnlationsContextValue {
  translationsPre: string;
  loggedValues: React.MutableRefObject<string[]>;
}

export const TranslationsContext = createContext<TrasnlationsContextValue>(
  {} as TrasnlationsContextValue
);

export const translationsHocSetup = (translationsPre: string) => (
  WrappedComponent: React.FC
) => (props: any) => {
  const loggedValues = useRef([]);

  return (
    <TranslationsContext.Provider value={{ translationsPre, loggedValues }}>
      <WrappedComponent {...props} />
    </TranslationsContext.Provider>
  );
};

export const MXAppTranslations = {
  translations: {
    pl
  },
  hoc: translationsHocSetup('')
};
